import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../../../shared/common.service';
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-notesmenu',
  templateUrl: './notesmenu.component.html',
  styleUrls: ['./notesmenu.component.scss']
})
export class NotesmenuComponent implements OnInit {
  NotesList: any;
  APPeriodId: any;
  NotejumpList: []; valueChanged: boolean; routeToCompanyList: boolean; jumpDisabale: boolean; jumpInsert: boolean; NotesData: any = []

  constructor(public commonService: CommonService, private route: Router,) {

  }
  public JumedNotes = new BehaviorSubject<any>(null)
  isJumpedNotes = this.JumedNotes.asObservable()
  setJumpedNotes(data) {
    this.JumedNotes.next(data)
  }
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.valueChanged && localStorage.getItem('isJump') =='false') {
      return Swal.fire({
        title: "Andica Accounts Production",
        //html: '<div class="noteswal mb-1"><div class="pe-2"><svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1" style="stroke: rgb(255 255 255);stroke-width: 2;fill: #f2ad40;stroke-linecap: round;stroke-linejoin: round;"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></div><div class="textDiv text-start mb-1"><span style="font-size: 16px;color:black;font-weight:bold">You have unsaved data.</span></br><span style="font-size: 14px;color:black;position: relative;top: -2px;">Do you want to save your changes before leaving</span></div></div>',
        html: "<span style='font-weight:900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false,
        /*position: 'top'*/
      }).then((result) => {
        if (result.value) {
          this.routeToCompanyList = true;
          this.insertNoteMenu()
          //this.Saveagent()
        }
        else {
          this.route.navigate[("business")]
          return true;
        }
      })
    }
    return true
  }
  ngOnInit() {
    debugger;
    /*this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)*/
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.getNotesData()
    if (localStorage.getItem("SubmitStatus") == "true")
      this.jumpDisabale = true;
    localStorage.setItem("isJump", 'false');
  }
  getNotesData() {
    debugger
    var id = this.commonService.AccountTemplateId
    this.commonService.getNoteMenuList(id, this.APPeriodId).subscribe(data => {
      this.NotesList = data
     
      if (this.commonService.AccountTypeId == 3) {
        this.NotesList = this.NotesList.filter(x => x.NotesDescription != 'Operating profit/(loss)' && x.NotesDescription != 'Turnover / revenue' && x.NotesDescription != 'Taxation')
      }
      //if (this.commonService.AccountTemplateId == 9) {
      //  this.NotesList = this.NotesList.filter(x => x.NotesDescription == 'Accounting Basis')
      //  this.NotesList.IsChecked = true;
      //}
      for (let i = 0; i < this.NotesList.length; i++) {
        this.NotesList[i].APPeriodId = this.APPeriodId
        this.NotesList[i].AccountTemplateId = this.commonService.AccountTemplateId
        var backbutton = localStorage.getItem("Backbutton");
        if (this.NotesList[i].NotesDescription == 'Land and buildings' || this.NotesList[i].NotesDescription == 'Plant Machinery' || this.NotesList[i].NotesDescription == 'Furniture and fittings' || this.NotesList[i].NotesDescription == 'Office Equipment' || this.NotesList[i].NotesDescription == 'Motor Vehicles' || this.NotesList[i].NotesDescription == 'Computer Equipment') {
          this.NotesList[i].isDisabled = true;
        }
        if (backbutton != "true") {
          if (this.NotesList[i].NotesDescription == 'General Information' || this.NotesList[i].NotesDescription == 'Statement of Compliance' || this.NotesList[i].NotesDescription == 'Accounting policies' || this.NotesList[i].NotesDescription == 'Employees' || this.NotesList[i].NotesDescription == 'Accounting Basis' ) {
            this.NotesList[i].IsChecked = true;
            if (this.NotesList[i].NotesDescription == 'Accounting policies' || this.NotesList[i].NotesDescription == 'Employees' || this.NotesList[i].NotesDescription == 'Accounting Basis' || this.NotesList[i].NotesDescription == 'Land and buildings' || this.NotesList[i].NotesDescription == 'Plant Machinery' || this.NotesList[i].NotesDescription == 'Furniture and fittings' || this.NotesList[i].NotesDescription == 'Office Equipment' || this.NotesList[i].NotesDescription == 'Motor Vehicles' || this.NotesList[i].NotesDescription == 'Computer Equipment') {
              this.NotesList[i].isDisabled = true;
            }
            else {
              this.NotesList[i].isDisabled = false;
            }
          }
        }
        else {
          if (this.NotesList[i].IsChecked != true)
            this.NotesList[i].IsChecked = false;
          else {
            this.NotesList[i].IsChecked = true;
            if (this.NotesList[i].NotesDescription == 'Accounting policies' || this.NotesList[i].NotesDescription == 'Employees' || this.NotesList[i].NotesDescription == 'Accounting Basis' || this.NotesList[i].NotesDescription == 'Land and buildings' || this.NotesList[i].NotesDescription == 'Plant Machinery' || this.NotesList[i].NotesDescription == 'Furniture and fittings' || this.NotesList[i].NotesDescription == 'Office Equipment' || this.NotesList[i].NotesDescription == 'Motor Vehicles') {
              this.NotesList[i].isDisabled = true;
            }
            else {
              this.NotesList[i].isDisabled = false;
            }
          }
        }
      }
      if (this.jumpDisabale) {
        for (let i = 0; i < this.NotesList.length; i++) {
          this.NotesList[i].isDisabled = true;
        }
      }
      this.NotejumpList = this.NotesList.filter(x => x.IsChecked == true)
      this.commonService.validService.next(this.NotejumpList)
    })
  }
  validationsOfNotesDeselection(event?) {
    if (this.NotesData.length > 0) {
      Swal.fire({
        //html: '<div class="noteswal"><div class="pe-2"><svg viewBox="0 0 24 24" width="28" height="28" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1" style="stroke: rgb(255 255 255);stroke-width: 2;fill: #f2ad40;stroke-linecap: round;stroke-linejoin: round;"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg></div><div class="textDiv text-start"><span style="font-size: 16px;color:black;font-weight:bold">Are you sure?</span></br><span style="font-size: 14px;color:black;position: relative;top: 5px;">Certain form(s) have been de-selected. Continuing will clear all the information on these form(s) and cannot be reversed. Do you want to continue? </span></div></div>',
        titleText: "Andica Accounts Production",
        text: "Certain form(s) have been de-selected, this will clear all the information for these form(s) and is irreversible. Do you want to continue?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.insertNoteMenuChanges(event)
        }
        else {
          for (let data of this.NotesData) {
            this.NotesList.filter(x => x.NotesDescription == data.NotesDescription)[0].IsChecked = true
          }
          this.insertNoteMenu(event)
        }
      })
    }
    else {
      this.insertNoteMenu(event)
    }
  }
  insertNoteMenu(event?) {
    debugger
    this.commonService.MouseEvent = event
    this.commonService.insertNoteMenu(this.NotesList).subscribe(data => {
      this.commonService.Isnavdata(3);
      this.commonService.setOpenAccountingPeriod(true)
      if (!this.jumpInsert) {
        localStorage.setItem("isJump", 'false')
        var nextnote;
        this.valueChanged = false;
        nextnote = this.commonService.getNextNoteSelection('', this.NotesList)
        if (this.routeToCompanyList)
          this.route.navigate[("business")]
        else
          this.route.navigate([nextnote])
      }
      else {
        this.setJumpedNotes(true)
      }
    })
  }
  insertNoteMenuChanges(event?) {
    debugger
    this.commonService.MouseEvent = event
    forkJoin(this.commonService.DeleteNotesData(this.APPeriodId, JSON.stringify(this.NotesData)), this.commonService.insertNoteMenu(this.NotesList),).subscribe(data => {
      this.commonService.Isnavdata(3);
      this.commonService.setOpenAccountingPeriod(true)
      if (!this.jumpInsert) {
        localStorage.setItem("isJump", 'false')
        var nextnote;
        this.valueChanged = false;
        nextnote = this.commonService.getNextNoteSelection('', this.NotesList)
        if (this.routeToCompanyList)
          this.route.navigate[("business")]
        else
          this.route.navigate([nextnote])
      }
      else {
        this.setJumpedNotes(true)
      }
    })
  }
  notesCheck(event, id) {
    debugger;
    if (event.target.checked) {
      this.NotesList.filter(x => x.MasterId == id)[0].IsChecked = event.target.checked;
      this.NotejumpList = this.NotesList.filter(x => x.IsChecked == true)
      this.commonService.validService.next(this.NotejumpList)
      this.valueChanged = true;
      var notedescription = this.NotesList.filter(x => x.MasterId == id)[0].NotesDescription
      this.NotesData = this.NotesData.filter(x => x.NotesDescription != notedescription)
      return
    }
    else {
      //Swal.fire({
      //  titleText: "Andica Accounts Production",
      //  text: "Certain form(s) have been de-selected, this will clear all the information for these form(s) and is irreversible. Do you want to continue?",
      //  icon: "question",
      //  showCancelButton: true,
      //  confirmButtonText: 'Yes',
      //  cancelButtonText: 'No',
      //  allowOutsideClick: false
      //}).then((data) => {
      //  if (data.value) {
      //    this.NotesList.filter(x => x.MasterId == id)[0].IsChecked = event.target.checked
      //    for (let i = 0; i < this.NotesList.length; i++) {
      //      if (this.NotesList[i].NotesDescription == 'Land and buildings' && this.NotesList[i].IsChecked == false) {
      //        this.commonService.Landandbuildings = false;
      //      } if (this.NotesList[i].NotesDescription == 'Plant Machinery' && this.NotesList[i].IsChecked == false) {
      //        this.commonService.PlantMachinery = false;
      //      } if (this.NotesList[i].NotesDescription == 'Furniture and fittings' && this.NotesList[i].IsChecked == false) {
      //        this.commonService.Furnitureandfittings = false;
      //      } if (this.NotesList[i].NotesDescription == 'Office Equipment' && this.NotesList[i].IsChecked == false) {
      //        this.commonService.OfficeEquipment = false;
      //      } if (this.NotesList[i].NotesDescription == 'Motor Vehicles' && this.NotesList[i].IsChecked == false) {
      //        this.commonService.MotorVehicles = false;
      //      }
      //      else {
      //      }
      //    }
      //    var description = this.NotesList.filter(x => x.MasterId == id)[0].NotesDescription
      //    this.commonService.DeleteNotesData(this.APPeriodId, description).subscribe((data) => {
      //    })
      //  }
      //  else {
      //    event.target.checked = true;
      //    this.NotesList.filter(x => x.MasterId == id)[0].IsChecked = event.target.checked;
      //  }
      this.NotesList.filter(x => x.MasterId == id)[0].IsChecked = event.target.checked
          for (let i = 0; i < this.NotesList.length; i++) {
            if (this.NotesList[i].NotesDescription == 'Land and buildings' && this.NotesList[i].IsChecked == false) {
              this.commonService.Landandbuildings = false;
            } if (this.NotesList[i].NotesDescription == 'Plant Machinery' && this.NotesList[i].IsChecked == false) {
              this.commonService.PlantMachinery = false;
            } if (this.NotesList[i].NotesDescription == 'Furniture and fittings' && this.NotesList[i].IsChecked == false) {
              this.commonService.Furnitureandfittings = false;
            } if (this.NotesList[i].NotesDescription == 'Office Equipment' && this.NotesList[i].IsChecked == false) {
              this.commonService.OfficeEquipment = false;
            } if (this.NotesList[i].NotesDescription == 'Motor Vehicles' && this.NotesList[i].IsChecked == false) {
              this.commonService.MotorVehicles = false;
            }
            else {
            }
          }
         var description = this.NotesList.filter(x => x.MasterId == id)[0].NotesDescription
         this.NotesData.push({ NotesDescription: description })
          //this.commonService.DeleteNotesData(this.APPeriodId, description).subscribe((data) => {
          //})

        this.NotejumpList = this.NotesList.filter(x => x.IsChecked == true)
        this.commonService.validService.next(this.NotejumpList)
        this.valueChanged = true;
      //})
    }
    //this.NotesList = Array.from(this.NotesList.reduce((m, t) => m.set(t.MasterId, t), new Map()).values())
    //this.NotesList.push(...this.commonService.allPagesdata)
    //this.pageselectiondata = Array.from(this.pageselectiondata.reduce((m, t) => m.set(t.FormId, t), new Map()).values())
  }
  goBack(event?){
    if (this.commonService.AccountTemplateId == 9 || this.commonService.AccountTemplateId == 10) {
      this.commonService.MouseEvent = event
      this.route.navigate(["statementoffinancialposition"])
    }
    else {
      var backpage = this.commonService.getPreviousPageSelection("Notes", this.commonService.allPagesdata)
      var selectedPagesData = this.commonService.allPagesdata.filter(x => x.IsDefault == true)
      const index = selectedPagesData.findIndex(item => item.FormId === 10);
      if (index != -1) {
        this.route.navigate(["detailedprofitandlossaccount"]);
      }
      else {
        this.commonService.MouseEvent = event
        this.route.navigate(["balancesheet"]);
      }
    }
  }
  
  jumpNextSection(event) {
    debugger
    if (this.commonService.NotesList?.length != this.NotesList.filter(x => x.IsChecked == true)?.length) {
      this.jumpInsert=true
      this.validationsOfNotesDeselection()
    }
    if (!this.jumpInsert) {
      localStorage.setItem("isJump", 'true')
      var jumpElement = event.target.value
      var jumpNote;
      jumpNote = this.commonService.getNextjumpSelection('', jumpElement);
      this.route.navigate([jumpNote])
    }
    else {
      this.isJumpedNotes.subscribe((data) => {
        if (data) {
          localStorage.setItem("isJump", 'true')
          var jumpElement = event.target.value
          var jumpNote;
          jumpNote = this.commonService.getNextjumpSelection('', jumpElement);
          this.route.navigate([jumpNote])
        }
      })
    }
  }
  Cancel() {
    this.commonService.DisplayAccountingPeriodlist = true;
    this.route.navigate(["business"])
  }
}
